module.exports = __webpack_public_path__ + "static/media/mobIcon.e71e8c06.svg";